

const Admin = [
  {
    label: "Dashboard",
    icon: "LayoutDashboard",
    link: "/admin/dashboard",
    name: "Dashboard"
  },

  {
    label: "Client",
    icon: "Users",
    link: "/admin/client",
    name: "Client"
  },
  {
    label: "Client Request",
    icon: "UserPen",
    link: "/admin/clientrequest",
    name: "ClientRequest"
  },
  {
    label: "Free Trial Client",
    icon: "FileUser",
    link: "/admin/freeclient",
    name: "FreeTrialClient"
  },
  {
    label: "Employee",
    icon: "CircleUserRound",
    link: "/admin/staff",
    name: "Employee"
  },
  {
    label: "Plan",
    icon: "Rocket",
    children: [
      { label: "Category", icon: "ClipboardType", link: "/admin/category", name: "Category" },
      { label: "Package", icon: "Repeat2", link: "/admin/plan", name: "Package" },
      // { label: "Segment", icon: "ScatterChart", link: "/admin/service", name: "Segment" },
      // { label: "Free Trial Status", icon: "Boxes", link: "/admin/freetrialstatus", name: "FreeTrialStatus" },
    ],
    name: "Plan",
  },
  {
    label: "Basket",
    icon: "ShoppingCart",
    children: [
      {
        label: "Basket Detail",
        icon: "ShoppingCart",
        link: "/admin/basket",
        name: "BasketDetail"
      },
      {
        label: "Basket Stock Published",
        icon: "Boxes", link: "/admin/basket/basketstockpublish",
        name: "BasketStockPublished"
      },
      {
        label: "Subscription History",
        icon: "FolderClock",
        link: "/admin/purchasebaskethistory",
        name: "SubscriptionHistory"
      },
    ],
    name: "Basket",
  },
  {
    label: "Signal",
    icon: "Activity",
    link: "/admin/signal",
    name: "Signal",
    children: [
      {
        label: "Open Signal",
        icon: "ScatterChart",
        link: "/admin/signal",
        name: "OpenSignal"
      },
      {
        label: "Close Signal",
        icon: "ScatterChart", link: "/admin/closesignal",
        name: "CloseSignal"
      },
      // {
      //   label: "Signal Strategy",
      //   icon: "Activity",
      //   link: "/admin/multiplesignal",
      //   name: "SignalStrategy"
      // },
    ],
  },
  // {
  //   label: "Multiple Strategy",
  //   icon: "Activity",
  //   children: [
  //     {
  //       label: "Open Signal Strategy",
  //       icon: "ScatterChart",
  //       link: "/admin/opensignalstrategy",
  //       name: "OpenSignalStrategy"
  //     },
  //     {
  //       label: "Close Signal Strategy",
  //       icon: "ScatterChart", link: "/admin/closecignalctrategy",
  //       name: "CloseSignalStrategy"
  //     },

  //   ],
  //   name: "MultipleSignal",
  // },
  {
    label: "Payment History",
    icon: "WalletCards",
    link: "/admin/paymenthistory",
    name: "PaymentHistory"
  },
  {
    label: "Withdrawal Request",
    icon: "ArrowRightLeft",
    link: "/admin/paymentrequest",
    name: "WithdrawalRequest"
  },
  {
    label: "Refer And Earn List",
    icon: "HelpingHand",
    link: "/admin/referAndEarnlist",
    name: "ReferAndEarnList"
  },
  {
    label: "Blogs",
    icon: "Paintbrush",
    link: "/admin/blogs",
    name: "Blogs"
  },
  {
    label: "News",
    icon: "Vote",
    link: "/admin/news",
    name: "News"
  },
  {
    label: "Coupon",
    icon: "Copyright",
    link: "/admin/coupon",
    name: "Coupon"
  },
  {
    label: "Banner",
    icon: "Frame",
    link: "/admin/banner",
    name: "Banner"
  },
  {
    label: "Scanner",
    icon: "Activity",
    children: [
      {
        label: "Scanner",
        icon: "ScanEye",
        link: "/admin/scanner-list",
        name: "scannerlist"
      },
      {
        label: "Scanner Order",
        icon: "ScanQrCode",
        link: "/admin/scanner-Order",
        name: "ScannerOrder"
      },
      {
        label: "Scanner View",
        icon: "ScanText",
        link: "/admin/scanner-View",
        name: "ScannerView"
      },
    ],
    name: "Scanner",
  },
  {
    label: "Client Plan Expiry",
    icon: "FolderClock",
    link: "/admin/planexpiry",
    name: "ClientPlanExpiry"
  },
  {
    label: "Performance",
    icon: "ScatterChart",
    link: "/admin/perfom",
    name: "Performance"
  },
  {
    label: "Basic Settings",
    icon: "Cog",
    children: [
      {
        label: "General Setting",
        icon: "Wrench",
        link: "/admin/generalsettings",
        name: "General Setting"
      },
      {
        label: "Email Setting",
        icon: "EthernetPort",
        link: "/admin/emailsetting",
        name: "Email Setting"
      },
      {
        label: "Notification Template",
        icon: "ClipboardType",
        link: "/admin/notification-template",
        name: "Notification Template"
      },
      {
        label: "API Information",
        icon: "Building2", link: "/admin/Apiinfo",
        name: "API  Information"
      },
      {
        label: "Payment Gateway",
        icon: "ArrowRightLeft",
        link: "/admin/paymentgeteway",
        name: "Payment Gateway"
      },
      {
        label: "Email Template",
        icon: "ClipboardType",
        link: "/admin/emailtemplate",
        name: "Email Template"
      },
      {
        label: "SMS Template",
        icon: "MessageCircle",
        link: "/admin/smstemplate",
        name: "SMS Template"
      },
      {
        label: "SMS Provider",
        icon: "CircleFadingArrowUp",
        link: "/admin/smsprovider",
        name: "SMS Provider"
      },
      {
        label: "Refer And Earn",
        icon: "HelpingHand",
        link: "/admin/referandearn",
        name: "Refer And Earn"
      },
      {
        label: "Auto SquareOff",
        icon: "CandlestickChart",
        link: "/admin/autosquareoff",
        name: "Auto Square Off"
      },
      {
        label: "Bank Detail",
        icon: "Wrench",
        link: "/admin/bankdetail",
        name: "Bank Detail"
      },
      {
        label: "QR Detail",
        icon: "Wrench",
        link: "/admin/QRdetails",
        name: "QR Detail"
      },
      {
        label:"Add To Cart Offer",
        icon:"BadgeDollarSign",
        link:"/admin/updateoffer",
        name:"Add To Cart Offer"
      },
      {
        label: "Home Banner Update",
        icon: "Frame",
        link: "/admin/homebannerupdate",
        name: "Home Banner Update"
      }
      // {
      //   label: "Description",
      //   icon: "Wrench",
      //   link: "/admin/popupdescription",
      //   name: "Description"
      // },
    ],
    name: "BasicSettings",
  },
  {
    label: "Order List",
    icon: "ListOrdered",
    link: "/admin/orderlist",
    name: "Order List"
  },
  // {
  //   label: "Stock Rating",
  //   icon: "ClipboardType",
  //   link: "/admin/stockrating",
  //   name: "StockRating"
  // },
  {
    label: "Broadcast",
    icon: "MessageCircleMore",
    link: "/admin/message",
    name: "Broadcast",
  },
  // {
  //   label: "Send Mail To Client",
  //   icon: "Mails",
  //   link: "/admin/addmail-to-client",
  //   name: "SendMailToClient"
  // },
  {
    label: "FAQ",
    icon: "FileQuestion",
    link: "/admin/faq",
    name: "FAQ"
  },
  {
    label: "Rating",
    icon: "Star",
    link: "/admin/rating-list",
    name: "Rating"
  },
  // {
  //   label: "Policy",
  //   icon: "Wrench",
  //   link: "/admin/termsandcondtion",
  //   name: "Policy"
  // },
  {
    label: "Help Disk",
    icon: "Ticket",
    link: "/admin/tickets",
    name: "HelpDisk"
  },
  {
    label: "UTM Source",
    icon: "Facebook",
    link: "/admin/utm-source",
    name: "utmSource"
  },
  {
    label: "Stockbox Policy",
    icon: "SquareCheckBig",
    link: "/admin/complain",
    children: [
      { label: "Complaint", icon: "BadgeAlert", link: "/admin/complain", name: "Complaint" },
      { label: "Grievance", icon: "BookmarkCheck", link: "/admin/grievance", name: "Grievance" },
      { label: "Regulatory", icon: "BadgeCheck", link: "/admin/regulatory", name: "Regulatory" },
      { label: "Policy", icon: "Wrench", link: "/admin/termsandcondtion", name: "Policy" },

    ],
    name: "Stockbox Policy",
  },
];


const SuperAdmin = [
  // {
  //   name: "Dashboard",
  //   label: "Dashboard",
  //   icon: "LayoutDashboard",
  //   link: "/superadmin/dashboard",
  //   children: [],
  // },
  {
    name: "Company",
    label: "Company",
    icon: "Building2",
    link: "/superadmin/company",
    children: [],
  },
  {
    name: "Themes",
    label: "Themes",
    icon: "Paintbrush",
    link: "/superadmin/themes",
    children: [],
  },

];


const User = [
  {
    name: "Dashboard",
    label: "Dashboard",
    icon: "LayoutDashboard",
    link: "/user/dashboard",
    children: [],
  },
  {
    name: "Service",
    label: "Services",
    icon: "ClipboardType",
    link: "/user/service",
    children: [],
  },
  {
    name: "Trades",
    label: "Trades",
    icon: "Activity",
    link: "/user/trades",
    children: [],
  },
  {
    name: "Strategy",
    label: "Strategy",
    icon: "GitCompare",
    link: "/user/strategy",
    children: [],
  },
  {
    name: "Basket",
    label: "Baskets",
    icon: "ShoppingCart",
    link: "/user/basket",
    children: [],
  },
  {
    name: "Subscription",
    label: "Subscription",
    icon: "Rocket",
    link: "/user/subscription",
    children: [],
  },
  {
    name: "Demat",
    label: "Demat",
    icon: "EthernetPort",
    link: "/user/demat",
    children: [],
  },
  // {
  //   name: "TradeResponse",
  //   label: "Trade Response",
  //   icon: "ArrowRightLeft",
  //   link: "/user/trade-response",
  //   children: [],
  // },
  {
    name: "Basket Response",
    label: "Basket Response",
    icon: "FolderClock",
    link: "/user/basket-response",
    children: [],
  },
  {
    name: "Broker Response",
    label: "Broker Response",
    icon: "FolderClock",
    link: "/user/broker-response",
    children: [],
  },
  // {
  //   name: "Coupons",
  //   label: "Coupons",
  //   icon: "Copyright",
  //   link: "/user/coupons",
  //   children: [],
  // },
  {
    name: "ReferEarn",
    label: "Refer & Earn",
    icon: "Puzzle",
    link: "/user/refer-earn",
    children: [],
  },
  {
    name: "Faqs",
    label: "Faqs",
    icon: "FileQuestion",
    link: "/user/faq",
    children: [],
  },

  {
    name: "Help Disk",
    label: "Help Disk",
    icon: "Ticket",
    link: "/user/help-desk",
    children: [],
  },
  {
    name: "Brodcast",
    label: "Broadcast",
    icon: "MessageCircleMore",
    link: "/user/broadcast",
    children: [],
  },
  // {
  //   name: "Notification",
  //   label: "Notification",
  //   icon: "Bell",
  //   link: "/user/notification",
  //   children: [],
  // },
  {
    name: "News",
    label: "News",
    icon: "Vote",
    link: "/user/news",
    children: [],
  },
  {
    name: "Blogs",
    label: "Blogs",
    icon: "Paintbrush",
    link: "/user/blogs",
    children: [],
  },
  // {
  //   name: "PaymentHistory",
  //   label: "Payment History",
  //   icon: "WalletCards",
  //   link: "/user/payment-history",
  //   children: [],
  // },
  // {
  //   name: "PastPerformance",
  //   label: "Past Performance",
  //   icon: "ScatterChart",
  //   link: "/user/past-performance",
  //   children: [],
  // },
  {
    label: "Our Policy",
    icon: "Handshake",
    children: [
      {
        name: "PrivacyPolicy",
        label: "Privacy Policy",
        icon: "Wrench",
        link: "/user/privacy-policy",

      },
      {
        name: "TermsConditions",
        label: "Terms & Conditions",
        icon: "Handshake",
        link: "/user/terms-conditions",
      },
      {
        name: "Disclaimer",
        label: "Disclaimer",
        icon: "ClipboardX",
        link: "/user/disclaimer",
      },

    ],
    name: "Our Policy",
  },
];


const Employee = [
  {
    label: "Dashboard",
    icon: "LayoutDashboard",
    link: "/employee/dashboard",
    name: "Dashboard"
  },

  {
    label: "Client",
    icon: "Users",
    link: "/employee/client",
    name: "Client"
  },
  {
    label: "Free Trial Client",
    icon: "UserPen",
    link: "/employee/freeclient",
    name: "FreeTrialClient"
  },
  {
    label: "Package",
    icon: "Repeat2",
    link: "/employee/plan",
    name: "Package"
  },
  {
    label: "Category",
    icon: "ClipboardType",
    link: "/employee/category",
    name: "Category"
  },
  {
    label: "Basket",
    icon: "ShoppingCart",
    children: [
      {
        label: "Basket Detail",
        icon: "ShoppingCart",
        link: "/employee/basket",
        name: "BasketDetail"
      },
      {
        label: "Basket Stock Published",
        icon: "Boxes",
        link: "/employee/basket/basketstockpublish",
        name: "BasketStockPublished"
      },
      {
        label: "Subscription History",
        icon: "FolderClock",
        link: "/employee/purchasebaskethistory",
        name: "SubscriptionHistory"
      },
    ],
    name: "Basket",
  },
  {
    label: "Signal",
    icon: "Activity",
    children: [
      {
        label: "Open Signal",
        icon: "ScatterChart",
        link: "/employee/signal",
        name: "OpenSignal"
      },
      {
        label: "Close Signal",
        icon: "ScatterChart", link: "/employee/closesignal",
        name: "CloseSignal"
      },

    ],
    name: "Signal",
  },
  {
    label: "Plan Expiry",
    icon: "FolderClock",
    link: "/employee/planexpiry",
    name: "PlanExpiry"
  },
  {
    label: "Performance",
    icon: "WalletCards",
    link: "/employee/perform",
    name: "Performance"
  },
  {
    label: "Blogs",
    icon: "Paintbrush",
    link: "/employee/blogs",
    name: "Blogs"
  },
  {
    label: "News",
    icon: "Vote",
    link: "/employee/news",
    name: "News"
  },
  {
    label: "Coupon",
    icon: "Copyright",
    link: "/employee/coupon",
    name: "Coupon"
  },
  {
    label: "Banner",
    icon: "Frame",
    link: "/employee/banner",
    name: "Banner"
  },
  {
    label: "FAQ",
    icon: "HelpingHand",
    link: "/employee/faq",
    name: "FAQ"
  },
  {
    label: "Payment History",
    icon: "WalletCards",
    link: "/employee/paymenthistory",
    name: "PaymentHistory"
  },
  {
    label: "Broadcast SMS",
    icon: "MessageCircleMore",
    link: "/employee/message",
    name: "BroadcastSMS"
  },
  {
    label: "Help Disk",
    icon: "Ticket",
    link: "/employee/tickets",
    name: "HelpDisk"
  },

];


export { SuperAdmin, Admin, User, Employee };

